// extracted by mini-css-extract-plugin
module.exports = {"inline":"Address-module__inline___1H0R8","address-component":"Address-module__address-component___1MjH_","addressComponent":"Address-module__address-component___1MjH_"};